<template>
    <div class="saveOrUpdateCrud">
        <div>
            <el-page-header @back="close" content="系统日志"></el-page-header>
        </div>
        <el-form :model="upsertForm"  :rules="rules" ref="upsertForm" label-width="80px" style="margin-top: 20px;" :inline="true" >
            <input type="hidden" :value="upsertForm.id">
              <el-form-item label="操作人" prop="adminName">
                 <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.adminName" auto-complete="off"></el-input>
             </el-form-item>
              <el-form-item label="用户操作" prop="operation">
                 <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.operation" auto-complete="off"></el-input>
             </el-form-item>
              <el-form-item label="响应时间" prop="time">
                 <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.time" auto-complete="off"></el-input>
             </el-form-item>
              <el-form-item label="请求方法" prop="method">
                 <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.method" auto-complete="off"></el-input>
             </el-form-item>
              <el-form-item label="请求参数" prop="params">
                 <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.params" auto-complete="off"></el-input>
             </el-form-item>
              <el-form-item label="IP地址" prop="ip">
                 <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.ip" auto-complete="off"></el-input>
             </el-form-item>
              <el-form-item label="响应结果" prop="result">
                 <el-input size="mini" maxlength="32" show-word-limit  v-model="upsertForm.result" auto-complete="off"></el-input>
             </el-form-item>
        </el-form>
        <div class="dialog-footer" style="text-align: center;">
            <el-button plain size="mini" @click="close">取 消</el-button>
            <el-button plain size="mini" type="primary" v-if="title=='增加'" v-display:sysLog-save @click="saveOrUpdate('upsertForm')">确 定</el-button>
            <el-button plain size="mini" type="primary" v-else v-display:sysLog-update @click="saveOrUpdate('upsertForm')">确 定</el-button>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "saveOrUpdateSysLog",
        props: ['title','id'],
        data(){
            return {
                upsertForm:{
                        id:'',
                        adminId:'',
                        adminName:'',
                        operation:'',
                        time:'',
                        method:'',
                        params:'',
                        ip:'',
                        result:'',
                        createTime:''
                },
                rules: {
                          adminId: [
                                  { required: true, message: '请输入用户id', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          adminName: [
                                  { required: true, message: '请输入操作人', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          operation: [
                                  { required: true, message: '请输入用户操作', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          time: [
                                  { required: true, message: '请输入响应时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          method: [
                                  { required: true, message: '请输入请求方法', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          params: [
                                  { required: true, message: '请输入请求参数', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          ip: [
                                  { required: true, message: '请输入IP地址', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          result: [
                                  { required: true, message: '请输入响应结果', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                          createTime: [
                                  { required: true, message: '请输入创建时间', trigger: 'blur' },
                                  {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                              ],
                }
            }
        },
        created(){
          if(this.title=='修改'){
              axios({
                  url:`${home}/sysLog/update/findSysLogById/${this.id}`,
                  method:'GET'
              }).then(res=>{
                  Object.assign(this.upsertForm,res.data);
              }).catch(error=>{

              })
          }
        },
        mounted(){

        },
        methods:{
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        axios({
                            url:`${home}/sysLog/${this.title==='增加'?'saveSysLog':'update/updateSysLog'}`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: this.title+'成功',
                                type: 'success'
                            });
                            this.$emit('closeSaveOrUpdate',true);
                        }).catch(error=>{
                            //do something
                        })


                    }
                })
            },
            close(){
                this.$emit('closeSaveOrUpdate');
            }
        }
    }
</script>

<style scoped lang="scss">
    .saveOrUpdateCrud{
        margin: 20px 0 0 10px;
    }
</style>